import classNames from 'classnames/bind';
import styles from './FullDashboard.module.css';
import { Header, ActivityDashboard } from '../';
import { ActivityCardData, DateRange } from '../../../types/dashboard';
import { ReactNode } from 'react';
import { Group } from '../../../types/common';

interface FullDashboardProps {
  title: string;
  cards: ActivityCardData[];
  groupList?: string[] | Group[];
  selectedGroup?: string;
  dateRange?: DateRange;
  actionButton?: {
    text: string;
    onClick: () => void;
    className?: string;
  };
  dateRangeDescSuffix?: string;
  onCardClick?: (cardId: string) => void;
  onDateChange?: (startDate: string, endDate: string) => void;
  onGroupChange?: (groupName: string, groupIndex: number) => void;
  className?: string;
  children?: ReactNode;
}

export default function FullDashboard({
  title,
  cards,
  groupList,
  selectedGroup,
  dateRange,
  actionButton,
  dateRangeDescSuffix,
  onCardClick,
  onDateChange,
  onGroupChange,
  className,
  children,
}: FullDashboardProps) {
  const cx = classNames.bind(styles);

  return (
    <div className={cx(className)}>
      <Header
        title={title}
        groupList={groupList}
        selectedGroup={selectedGroup}
        onGroupChange={onGroupChange}
      />
      <ActivityDashboard
        cards={cards}
        dateRange={dateRange}
        actionButton={actionButton}
        dateRangeDescSuffix={dateRangeDescSuffix}
        onCardClick={onCardClick}
        onDateChange={onDateChange}
      >
        {children}
      </ActivityDashboard>
    </div>
  );
}
